import { render } from "./settingsPanels.vue?vue&type=template&id=ff08c1c4&scoped=true"
import script from "./settingsPanels.vue?vue&type=script&lang=js"
export * from "./settingsPanels.vue?vue&type=script&lang=js"

import "./settingsPanels.vue?vue&type=style&index=0&id=ff08c1c4&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff08c1c4"]])

export default __exports__